export const specialChars: any = {
  ą: 'a',
  Ą: 'A',
  ę: 'e',
  Ę: 'E',
  ó: 'o',
  Ó: 'O',
  ś: 's',
  Ś: 'S',
  ł: 'l',
  Ł: 'L',
  ż: 'z',
  Ż: 'Z',
  ź: 'z',
  Ź: 'Z',
  ć: 'c',
  Ć: 'C',
  ń: 'n',
  Ń: 'N',
  č: 'c',
  ď: 'd',
  ň: 'n',
  ř: 'r',
  š: 's',
  ť: 't',
  Š: 'S',
  Œ: 'O',
  Ž: 'Z',
  œ: 'o',
  ž: 'z',
  Ÿ: 'Y',
  ÿ: 'y',
  µ: 'U',
  À: 'A',
  Á: 'A',
  Â: 'A',
  Ã: 'A',
  Ä: 'A',
  Å: 'A',
  Æ: 'A',
  Ç: 'C',
  È: 'E',
  É: 'E',
  Ê: 'E',
  Ë: 'E',
  Ì: 'I',
  Í: 'I',
  Î: 'I',
  Ï: 'I',
  Ð: 'D',
  Ñ: 'N',
  Ò: 'O',
  Ô: 'O',
  Õ: 'O',
  Ö: 'O',
  Ø: 'O',
  Ù: 'U',
  Ú: 'U',
  Û: 'U',
  Ü: 'U',
  Ý: 'Y',
  ß: 's',
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  æ: 'a',
  ç: 'c',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ð: 'o',
  ñ: 'n',
  ò: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ø: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  ý: 'y',
  '¥': 'Y',
  '&': 'and',
};
